import CustomZObject from './CustomZObject.js';
import {
    setPianoRollCursor,
    setArrangementMouseX,
    setArrangementCursorStep} from 'actions/index.js';

export default class ZMixButtons extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        // sends 1 when playing and 0 when stopped
        /*
        this.newInlet("start/stop", ([x]) => {
            if (x) {

            } else {
            }

        });
        */
        this.newOutlet("playing");
        this.newOutlet("stepNumber offset");
        this.newOutlet("current stepNumber");

        zobject.sequencerEngine.mixButtons.push(this);

        this.newInlet("pause vs stop", ([x]) => this.onPauseOrStop(x));
        this.newInlet("toggle play/stop", ([x]) => this.onToggle(x));
        this.newInlet("stop", ([x]) => this.onStop());
    }

    onToggle(x) {
        this.sequencerEngine.schedulePlay();
    }

    onStop() {
        this.sequencerEngine.stop();
        this.sequencerEngine.seekToTrackStep(0);
        this.sequencerEngine.dispatch(setPianoRollCursor(undefined));
        this.sequencerEngine.dispatch(setArrangementMouseX(undefined));
        this.sequencerEngine.dispatch(setArrangementCursorStep(0));
    }

    sendCurrentStepNumber(x) {
        this.sendMessage('current stepNumber', x);
    }

    onPauseOrStop(x) {
        this.pauseOrStop = x;
    }

    handleStop() {
        if (this.pauseOrStop) {
            // then we should pause upon "stopping music"
            let trackStep = this.sequencerEngine.lastTrackStep || 0;
            trackStep += this.sequencerEngine.stepNumberOffset || 0;
            this.sequencerEngine.stepNumberOffset = trackStep;
            this.sendMessage("stepNumber offset", trackStep);
        }
    }
}
